// extracted by mini-css-extract-plugin
module.exports = {"table":"TechnicalSpecsDetailsTable_table__3mIEx","td":"TechnicalSpecsDetailsTable_td__1zQF4","th":"TechnicalSpecsDetailsTable_th__JpUAq"};